// src/lib/firebase.js
import { initializeApp, getApps } from 'firebase/app';
import { getAnalytics, isSupported as analyticsSupported } from 'firebase/analytics';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FB_API_KEY,
  authDomain: process.env.REACT_APP_FB_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FB_PROJECT_ID,
  appId: process.env.REACT_APP_FB_APP_ID,
  storageBucket: process.env.REACT_APP_FB_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FB_MSID,
  measurementId: process.env.REACT_APP_FB_MEASUREMENT_ID
};

if (process.env.NODE_ENV !== 'production') {
  const missing = Object.entries({
    REACT_APP_FB_API_KEY: firebaseConfig.apiKey,
    REACT_APP_FB_AUTH_DOMAIN: firebaseConfig.authDomain,
    REACT_APP_FB_PROJECT_ID: firebaseConfig.projectId,
    REACT_APP_FB_APP_ID: firebaseConfig.appId,
  }).filter(([, v]) => !v).map(([k]) => k);
  if (missing.length) {
    console.error('Missing Firebase env vars:', missing.join(', '));
  }
}

// Initialize once
export const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
export const storage = getStorage(app);

// Initialize Analytics
export let analytics = null;
(async () => {
  try {
    if (firebaseConfig.measurementId && (await analyticsSupported())) {
      analytics = getAnalytics(app);
    }
  } catch (_) { }
})();
